// extracted by mini-css-extract-plugin
export var content = "_8w-3";
export var list = "_8w-4";
export var settingsContent = "_8w-7";
export var settingsPanel = "_8w-8";
export var state = "_8w-6";
export var triggerBadge = "_8w-2";
export var triggerButton = "_8w-1";
export var triggerShell = "_8w-0";
export var unreadDot = "_8w-5";